import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card } from '@/components/ui/card';

const Privacy = () => {
  const { language } = useLanguage();

  return (
    <div className={`min-h-screen bg-adalat-gradient ${language === 'ur' ? 'font-urdu' : 'font-english'}`}>
      <div className="container mx-auto py-8 px-4">
        <div className="flex justify-between items-center mb-8">
          <Header />
          <LanguageSwitcher />
        </div>

        <main className={`max-w-4xl mx-auto ${language === 'ur' ? 'rtl' : 'ltr'}`}>
          <Card className="p-8">
            <h1 className={`${language === 'ur' ? 'text-urdu-3xl text-right' : 'text-4xl'} font-bold mb-6 text-blue-700`}>
              {language === 'ur' ? 'رازداری کی پالیسی' : 'Privacy Policy'}
            </h1>

            <div className="space-y-6">
              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۱. معلومات کی جمع آوری' : '1. Information Collection'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700 mb-3`}>
                  {language === 'ur'
                    ? 'ہم درج ذیل قسم کی معلومات جمع کرتے ہیں:'
                    : 'We collect the following types of information:'}
                </p>
                <ul className={`list-disc ${language === 'ur' ? 'list-inside text-right' : 'ml-6'} space-y-2`}>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'ذاتی معلومات: نام، ای میل، فون نمبر (اگر فراہم کی جائیں)'
                      : 'Personal information: Name, email, phone number (if provided)'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'استعمال کی معلومات: آپ جو دستاویزات تیار کرتے ہیں اور استعمال کی تفصیلات'
                      : 'Usage information: Documents you create and usage details'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'تکنیکی معلومات: IP ایڈریس، براؤزر کی قسم، ڈیوائس کی معلومات'
                      : 'Technical information: IP address, browser type, device information'}
                  </li>
                </ul>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۲. معلومات کا استعمال' : '2. Use of Information'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700 mb-3`}>
                  {language === 'ur'
                    ? 'ہم آپ کی معلومات کا استعمال یہاں کے لیے کرتے ہیں:'
                    : 'We use your information for:'}
                </p>
                <ul className={`list-disc ${language === 'ur' ? 'list-inside text-right' : 'ml-6'} space-y-2`}>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'دستاویزات تیار کرنے اور سروس فراہم کرنے کے لیے'
                      : 'To generate documents and provide services'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'صارف کے تجربے کو بہتر بنانے کے لیے'
                      : 'To improve user experience'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'اپ ڈیٹس اور نوٹیفکیشن بھیجنے کے لیے'
                      : 'To send updates and notifications'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'سیکیورٹی اور فراڈ سے بچاؤ کے لیے'
                      : 'For security and fraud prevention'}
                  </li>
                </ul>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۳. ڈیٹا کی حفاظت' : '3. Data Protection'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'ہم آپ کی معلومات کی حفاظت کے لیے جدید تکنیکی اقدامات استعمال کرتے ہیں۔ آپ کا تمام ڈیٹا انکرپٹ کیا جاتا ہے اور محفوظ سرورز پر محفوظ رکھا جاتا ہے۔ ہم SSL/TLS انکرپشن استعمال کرتے ہیں تاکہ آپ کی معلومات کی منتقلی محفوظ ہو۔'
                    : 'We use advanced technical measures to protect your information. All your data is encrypted and stored on secure servers. We use SSL/TLS encryption to ensure secure data transmission.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۴. معلومات کا اشتراک' : '4. Information Sharing'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'ہم آپ کی ذاتی معلومات کسی تیسرے فریق کے ساتھ شیئر نہیں کرتے، سوائے:'
                    : 'We do not share your personal information with third parties, except:'}
                </p>
                <ul className={`list-disc ${language === 'ur' ? 'list-inside text-right' : 'ml-6'} space-y-2 mt-3`}>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'جب قانون کی ضرورت ہو'
                      : 'When required by law'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'جب آپ کی اجازت ہو'
                      : 'When you give permission'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'ضروری سروس فراہم کنندگان کے ساتھ (جو رازداری کے معاہدے کے پابند ہیں)'
                      : 'With essential service providers (who are bound by confidentiality agreements)'}
                  </li>
                </ul>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۵. کوکیز' : '5. Cookies'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'ہم کوکیز استعمال کرتے ہیں تاکہ آپ کے تجربے کو بہتر بنایا جا سکے اور ویب سائٹ کی کارکردگی کو ٹریک کیا جا سکے۔ آپ اپنے براؤزر کی ترتیبات میں کوکیز کو غیر فعال کر سکتے ہیں، لیکن اس سے سائٹ کی کچھ خصوصیات متاثر ہو سکتی ہیں۔'
                    : 'We use cookies to improve your experience and track website performance. You can disable cookies in your browser settings, but this may affect some site features.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۶. آپ کے حقوق' : '6. Your Rights'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700 mb-3`}>
                  {language === 'ur'
                    ? 'آپ کو یہ حقوق حاصل ہیں:'
                    : 'You have the following rights:'}
                </p>
                <ul className={`list-disc ${language === 'ur' ? 'list-inside text-right' : 'ml-6'} space-y-2`}>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'اپنی معلومات تک رسائی حاصل کرنا'
                      : 'Access your information'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'غلط معلومات کو درست کرنا'
                      : 'Correct incorrect information'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'اپنی معلومات کو حذف کرنے کی درخواست کرنا'
                      : 'Request deletion of your information'}
                  </li>
                  <li className={`${language === 'ur' ? 'text-urdu-base' : 'text-base'} text-gray-700`}>
                    {language === 'ur'
                      ? 'ڈیٹا پروسیسنگ پر اعتراض کرنا'
                      : 'Object to data processing'}
                  </li>
                </ul>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۷. بچوں کی رازداری' : '7. Children\'s Privacy'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'ہماری سروس 18 سال سے کم عمر کے بچوں کے لیے نہیں ہے۔ ہم جان بوجھ کر 18 سال سے کم عمر بچوں کی معلومات جمع نہیں کرتے۔'
                    : 'Our service is not for children under 18 years of age. We do not knowingly collect information from children under 18.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۸. پالیسی میں تبدیلیاں' : '8. Policy Changes'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'ہم اپنی رازداری کی پالیسی میں کسی بھی وقت تبدیلی کر سکتے ہیں۔ تبدیلیاں اس صفحے پر شائع کی جائیں گی۔ اہم تبدیلیوں کی صورت میں ہم آپ کو مطلع کریں گے۔'
                    : 'We may change our privacy policy at any time. Changes will be published on this page. We will notify you of significant changes.'}
                </p>
              </section>

              <section>
                <h2 className={`${language === 'ur' ? 'text-urdu-2xl text-right' : 'text-2xl'} font-semibold mb-3 text-blue-600`}>
                  {language === 'ur' ? '۹. رابطہ' : '9. Contact'}
                </h2>
                <p className={`${language === 'ur' ? 'text-urdu-base text-right' : 'text-base'} text-gray-700`}>
                  {language === 'ur'
                    ? 'اگر آپ کو رازداری کے بارے میں کوئی سوال یا خدشات ہیں، تو براہ کرم ہم سے رابطہ کریں۔ ہم آپ کی پریشانیوں کو حل کرنے کے لیے پرعزم ہیں۔'
                    : 'If you have any questions or concerns about privacy, please contact us. We are committed to resolving your concerns.'}
                </p>
              </section>

              <div className="mt-8 p-4 bg-blue-50 rounded-lg">
                <p className={`${language === 'ur' ? 'text-urdu-sm text-right' : 'text-sm'} text-gray-600`}>
                  {language === 'ur'
                    ? 'آخری اپ ڈیٹ: جنوری 2025'
                    : 'Last Updated: January 2025'}
                </p>
              </div>
            </div>
          </Card>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default Privacy;